import script from "./RadarOrBarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./RadarOrBarChart.vue?vue&type=script&lang=ts&setup=true"

import "./RadarOrBarChart.vue?vue&type=style&index=0&id=7f392021&lang=css"
import "./RadarOrBarChart.vue?vue&type=style&index=1&id=7f392021&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f392021"]])

export default __exports__